import React, { useState, useEffect, useContext, ReactElement, cloneElement, use } from 'react';
import { fillDashboard,getStatusList,releaseGetNext,runQuery, updateTraffic } from '../services/apiService';
import {Grid, GridColumn as Column, GridPageChangeEvent, GridDataStateChangeEvent, GridToolbar, getSelectedState, GridSelectionChangeEvent, GridCustomCellProps, GridDetailRowProps, GridSortChangeEvent, GridFilterChangeEvent, GridColumnReorderEvent, GridColumnProps, GridColumn} from '@progress/kendo-react-grid';
import { ExcelExport } from '@progress/kendo-react-excel-export';
import { Button } from '@progress/kendo-react-buttons';
import { PagerTargetEvent, SelectDescriptor } from '@progress/kendo-react-data-tools';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCircle} from '@fortawesome/free-solid-svg-icons';
import { process, State, DataResult, FilterDescriptor, CompositeFilterDescriptor, SortDescriptor, orderBy, filterBy } from '@progress/kendo-data-query';
import { GridColumnMenuFilter, GridColumnMenuProps } from '@progress/kendo-react-grid';
import { filterIcon } from '@progress/kendo-svg-icons';
import { getter } from '@progress/kendo-react-common';
import { longDateTime } from '../services/interfaces';
import { gSettings } from './Configuration';
import { PageContext } from './PageContext';
import { adRecord } from '../services/interfaces';
import { DropDownList,DropDownListFilterChangeEvent, DropDownListChangeEvent, ListItemProps, MultiSelect, MultiSelectChangeEvent, MultiSelectFilterChangeEvent } from '@progress/kendo-react-dropdowns';
import { DatePicker, DatePickerChangeEvent } from '@progress/kendo-react-dateinputs';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { rollUpGroup } from '../services/interfaces';
import { getUserRollUpGroups, getTrafficUserList, getTrafficStatusList,getTrafficCCSubStatusList,requestCreative } from '../services/apiService';
import { fillTrafficGrid,fillToningJobList } from '../services/apiService';
import { ConfirmDialog,AlertDialog } from './ConfirmDialog';
import { UserContext } from './UserContext';


interface dashCol{
    field:string,
    title:string,
    width:number,
    filter:boolean,
    format:string,
    minScreenWidth:number
}

interface dashboardGridProps{
    id:string,
    statuses:string,
    export:boolean,
    cols:dashCol[],
    watch?:boolean,
    search?:boolean,
    reorderCols:(e:GridColumnReorderEvent)=>void
}

interface PageState {
    skip: number;
    take: number;
}

interface filterItem{
    name:string,
    value:number
}

interface trafficUser{
    username:string,
    fullname:string
}
interface trafficStatus{
    status:string,
    color:string,
    displayOrder:number
}



const initialPageState: PageState = { skip: 0, take: 20 };

const initialDataState: State = {
    sort: [{ field: 'pubDate', dir: 'asc' }],
    skip: 0,
    take: 20
};

const ColumnMenu = (props: GridColumnMenuProps) => {
    return (
        <div>
            <GridColumnMenuFilter {...props} expanded={true} />
        </div>
    );
};

export function DashboardGrid (props:dashboardGridProps){
    const [dashData, setDashData] = useState([]);
    const [sort,setSort]=useState<SortDescriptor[]>([{ field: 'pubDate', dir: 'asc' }])
    const [filter,setFilter]=useState<CompositeFilterDescriptor>({
        logic:'and',
        filters:[]
    })
    const [select,setSelect]=useState<SelectDescriptor>();
    const [dataState, setDataState]=useState<State>(initialDataState);
    const [dataResult, setDataResult]=useState<DataResult>(process(dashData,dataState));
    const [selectedState, setSelectedState] = React.useState<{
        [id: string]: boolean | number[];
    }>({});
    const [locale, setLocale] = useState<string | undefined>(undefined);

    const [page, setPage] = React.useState<PageState>(initialPageState);
    const idGetter = getter('element');
    const [gridKey, setGridKey]=useState(1);
    interface StatusItem {
        status: string;
        color: string;
    }
    
    const onDataStateChange = (e: GridDataStateChangeEvent) => {
        const NewDataState = {...e.dataState, skip:e.dataState.skip===undefined?0:e.dataState.skip, take:e.dataState.take===undefined?20:e.dataState.take}
        setDataState(NewDataState);
        //getData();
        const newStateData = process(dashData,NewDataState);
        setDataResult(newStateData);
    };

    const [statList, setStatList] = useState<StatusItem[]>([]);
    const pageChange = (event: GridPageChangeEvent) => {
        const targetEvent = event.targetEvent as PagerTargetEvent;
        const NewDataState = {...dataState, skip:event.page.skip,take:event.page.take}
        const newStateData = process(dashData,NewDataState);
        setDataResult(newStateData);
        setPage(event.page);
        //setPage({
        //    ...event.page,
        //    take:20
        //});
    }

    const statusList = ()=>{
        const statList = getStatusList()
        .then(data=>{setStatList(data)});
    }

    
    

    function formatColumn(gridCell:GridCustomCellProps) {
        //, format:string, fieldName:string
        //console.log(gridCell);
        //console.log(gridCell.field);
        const fieldName=gridCell.field;
        const format: string = gridCell.format||'';
        
        switch (format){
           case "status":
                //format a status list column
                const matchStat = statList.find(item => item.status === gridCell.dataItem[fieldName||'']);
                const color = matchStat?.color.replace(" ", "_");
                return (
                    <td {...gridCell.tdProps}>
                        <span style={{ color: color }}>
                            <FontAwesomeIcon icon={faCircle}></FontAwesomeIcon>
                        </span>&emsp;{gridCell.dataItem.status}
                    </td>
                );
                break;
            case "longdate":
                //format a long date to date format
                console.log(fieldName)
                if (fieldName){
                    console.log(gridCell.dataItem[fieldName])
                }
                const longStr = (gridCell.dataItem[fieldName||'']).toString();
                const longDate:longDateTime = {
                    year:longStr.substring(0,4),
                    month:longStr.substring(4,6),
                    day:longStr.substring(6,8),                    
                }
                const newDate=new Date(longDate.month+"/"+longDate.day+"/"+longDate.year);
                 return (
                     <td {...gridCell.tdProps}>
                        {newDate.toLocaleDateString(locale)}
                     </td>
                 )
                break;
            case "longdatetime":
                const longDtStr = (gridCell.dataItem[fieldName||'']).toString();
                const longDateTime:longDateTime = {
                    year:longDtStr.substring(0,4),
                    month:longDtStr.substring(4,6),
                    day:longDtStr.substring(6,8),
                    hour:longDtStr.substring(8,10),
                    minute:longDtStr.substring(10,12),
                    second:longDtStr.substring(12,14),
                }
                //console.log(longDateTime);

                const newDateTime=new Date(longDateTime.month+"/"+longDateTime.day+"/"+longDateTime.year +" "+ longDateTime.hour + ":" + longDateTime.minute + ":" + longDateTime.second);
                //console.log(newDateTime);

                return (
                    <td {...gridCell.tdProps}>
                    {locale ? newDateTime.toLocaleString(locale) : newDateTime.toLocaleString()}
                    </td>
                )
                break;
            default:
                return(
                    <td {...gridCell.tdProps}>
                        {gridCell.field ? gridCell.dataItem[gridCell.field] : null}
                    </td>
                )
                break;
        }        
    }
    const _export = React.useRef<ExcelExport | null>(null);
    const excelExport = () => {
        console.log(_export.current);
        console.log(dashData);
        if (_export.current !== null) {
            _export.current.save(dashData);
        }
    };
    const pageContext = useContext(PageContext);
    const toggleExpand=()=>pageContext?.setShowExpand(!pageContext?.showExpand);

    const onSelectionChange = (event: GridSelectionChangeEvent) => {
        console.log("Selection changed");
        //console.log(event.startDataItem);
        const adRecord:adRecord=event.startDataItem;
        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedState,
            dataItemKey: "element"
        });
        //console.log(Object.keys(newSelectedState)[0]);
        setSelectedState(newSelectedState);
        pageContext?.setSelectedAd(adRecord);
        toggleExpand();
    };
    const getData=()=>{
        statusList();
        fillDashboard(props.statuses).then(data => {
            setDashData(data);
            setDataResult(process(data, dataState));
        });
    }

    const forceRender=()=>{
        console.log("Force Render");
        setGridKey(gridKey+1);
    }

    const showHide=(column:dashCol)=>{
        if (column.minScreenWidth && column.minScreenWidth>0){
            const screenWidth = window.innerWidth;
            if (screenWidth>column.minScreenWidth){
                return true;
            }else{
                return false;
            }

        }
    }

    const thisGrid=()=>{
        const isColumnFiltered = (columnField: string) => {
            var isFilter = false;
            if (dataState.filter){
                dataState.filter.filters.forEach(c=>{
                    (c as CompositeFilterDescriptor).filters.forEach(f=>{
                        if ((f as FilterDescriptor).field===columnField){
                            isFilter=true;
                        }
                    })
                })
            }
            return isFilter;                
        };
        return(
        <Grid
            id={props.id}
            key={gridKey}
            className='dashGrid'
            sortable={true}
            //sort={sort}
            selectable={{ enabled:true, mode: 'single' }}
            pageable={true}
            pageSize={20}            
            {...dataState}
            onDataStateChange={onDataStateChange}
            //onPageChange={pageChange}
            total={dataResult.total}
            reorderable={true}
            dataItemKey={'element'}
            data={dataResult.data.map((item)=>({
                 ...item, 'selected':selectedState[idGetter(item)]
             }))}
            columnMenuIcon={filterIcon}
            //selectedField={'selected'}
            onSelectionChange={onSelectionChange}
            onColumnReorder={props.reorderCols}
        >
            <GridToolbar>
            <Button title="Refresh" themeColor={'primary'} type="button" onClick={getData} style={{marginRight:"10px"}}>Refresh</Button>
            {props.export?
                <Button title="Export Excel" themeColor={'primary'} type="button" onClick={excelExport}>
                    Export to Excel
                </Button>
            :<></>}
            </GridToolbar>

            {props.cols.map((column)=>{
                //console.og(column);
                    return(
                        <Column
                            {...(column.minScreenWidth && column.minScreenWidth>0 ? {media: `(min-width:${column.minScreenWidth}px)`} : {})}
                            field={column.field} 
                            title={column.title} 
                            width={column.width}
                            format={column.format}
                            key={"element"}
                            headerClassName={isColumnFiltered(column.field)?"filteredColumn":""}
                            cells={{data:(cellProps)=>(
                                column.format!=null?formatColumn(cellProps):<td {...cellProps.tdProps}>{cellProps.dataItem[column.field]}</td>                            
                            )}}
                            columnMenu={column.filter ? ColumnMenu : undefined} 
                        />
                    );
            })}
        </Grid>
        );
    }
    useEffect(()=>{
        getData();
    },[dataState])

    useEffect(()=>{
        forceRender();
    },[props.cols])

    useEffect(()=>{
        getData();
        pageContext?.setRefreshActiveGrid(false);
        //gSettings().then(settings => setLocale(settings.Locale));
    },[pageContext?.refreshActiveGrid==true]);
    
    useEffect(() => {
        getData();
        gSettings().then(settings => setLocale(settings.Locale));
    }, []);

    return (
        <>
        {props.export?
            <ExcelExport data={dashData} ref={_export}>
                {thisGrid()}
            </ExcelExport>
        : thisGrid()
        }
         </>
    );
}

export function TrafficGrid (props:dashboardGridProps){
    const [dashData, setDashData] = useState<any[]>([]);
    const [dataState, setDataState]=useState<State>(initialDataState);
    const [dataResult, setDataResult]=useState<DataResult>(process(dashData,dataState));
    const [selectedState, setSelectedState] = React.useState<{
        [id: string]: boolean | number[];
    }>({});
    const [locale, setLocale] = useState<string | undefined>(undefined);
    const [filter,setFilter]=useState<CompositeFilterDescriptor>({
            logic:'and',
            filters:[]
    })
    const [page, setPage] = React.useState<PageState>(initialPageState);
    const idGetter = getter('element');
    const [ruGroups,setRuGroups]=useState<Array<rollUpGroup>>([]);
    const [selGroup, setSelGroup]=useState<rollUpGroup>();
    const [selFilter, setSelFilter]=useState<filterItem>({ name: "Show All", value: 0 });
    const [selpagDate,setSelPagDate]=useState<Date>();
    const [selpagEndDate,setSelPagEndDate]=useState<Date>();
    const [trafficUsers, setTrafficUsers] = useState<trafficUser[]>([]);
    const [trafficStatus,setTrafficStatus]=useState<trafficStatus[]>([]);
    const [trafficCCSubStatus,setTrafficCCSubStatus]=useState<trafficStatus[]>([]);
    const [trafficAssignedTo, setTrafficAssignedTo]=useState<trafficUser>({fullname:"", username:""});
    const [trafficSelStatus,setTrafficSelStatus]=useState<trafficStatus>({status:"",color:"",displayOrder:0});
    const [trafficSelCCSubStatus,setTrafficSelCCSubStatus]=useState<trafficStatus>({status:"",color:"",displayOrder:0});
    const [showBulkAssign, setShowBulkAssign]= useState(false);
    const [showRequestCreative, setShowRequestCreative]=useState(false);
    const [bulkAssignUser, setBulkAssignUser]=useState<trafficUser | undefined>();
    const [creativeMsg,setCreativeMsg]=useState("");

    interface StatusItem {
        status: string;
        color: string;
    }

    const onDataStateChange = (e: GridDataStateChangeEvent) => {
        const NewDataState = {...e.dataState, skip:e.dataState.skip===undefined?0:e.dataState.skip, take:e.dataState.take===undefined?20:e.dataState.take}
        pageContext?.setTrafficDataState(NewDataState);
        //getData();
        const newStateData = process(dashData,NewDataState);
        setDataResult(newStateData);
    };

    const [statList, setStatList] = useState<StatusItem[]>([]);
    const pageChange = (event: GridPageChangeEvent) => {
        const targetEvent = event.targetEvent as PagerTargetEvent;        
        setPage({
            ...event.page,
            take:20
        });
    }

    const statusList = ()=>{
        const statList = getStatusList()
        .then(data=>{setStatList(data)});
    }

    function formatColumn(gridCell:GridCustomCellProps) {
        //, format:string, fieldName:string
        //console.log(gridCell);
        //console.log(gridCell.field);
        const fieldName=gridCell.field;
        const format: string = gridCell.format||'';
        
        switch (format){
           case "status":
                //format a status list column
                const matchStat = statList.find(item => item.status === gridCell.dataItem[fieldName||'']);
                const color = matchStat?.color.replace(" ", "_");
                return (
                    <td {...gridCell.tdProps}>
                        <span style={{ color: color }}>
                            <FontAwesomeIcon icon={faCircle}></FontAwesomeIcon>
                        </span>&emsp;{gridCell.dataItem.status}
                    </td>
                );
                break;
            case "longdate":
                //format a long date to date format
                if (fieldName){
                    console.log(gridCell.dataItem[fieldName])
                }
                const longStr = (gridCell.dataItem[fieldName||'']).toString();
                const longDate:longDateTime = {
                    year:longStr.substring(0,4),
                    month:longStr.substring(4,6),
                    day:longStr.substring(6,8),                    
                }
                const newDate=new Date(longDate.month+"/"+longDate.day+"/"+longDate.year);
                 return (
                     <td {...gridCell.tdProps}>
                        {newDate.toLocaleDateString(locale)}
                     </td>
                 )
                break;
            case "longdatetime":
                const longDtStr = (gridCell.dataItem[fieldName||'']).toString();
                const longDateTime:longDateTime = {
                    year:longDtStr.substring(0,4),
                    month:longDtStr.substring(4,6),
                    day:longDtStr.substring(6,8),
                    hour:longDtStr.substring(8,10),
                    minute:longDtStr.substring(10,12),
                    second:longDtStr.substring(12,14),
                }
                //console.log(longDateTime);

                const newDateTime=new Date(longDateTime.month+"/"+longDateTime.day+"/"+longDateTime.year +" "+ longDateTime.hour + ":" + longDateTime.minute + ":" + longDateTime.second);
                //console.log(newDateTime);

                return (
                    <td {...gridCell.tdProps}>
                    {locale ? newDateTime.toLocaleString(locale) : newDateTime.toLocaleString()}
                    </td>
                )
                break;
            default:
                return(
                    <td {...gridCell.tdProps}>
                        {gridCell.field ? gridCell.dataItem[gridCell.field] : null}
                    </td>
                )
                break;
        }        
    }
    const _export = React.useRef<ExcelExport | null>(null);
    const excelExport = () => {
        if (_export.current !== null) {
            _export.current.save(dashData);
        }
    };
    const pageContext = useContext(PageContext);
    const toggleExpand=()=>pageContext?.setShowExpand(!pageContext?.showExpand);

    const onSelectionChange = (event: GridSelectionChangeEvent) => {
        console.log("Selection changed");
        //console.log(event.startDataItem);
        const adRecord:adRecord=event.startDataItem;
        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedState,
            dataItemKey: "element"
        });
        //console.log(Object.keys(newSelectedState)[0]);
        setSelectedState(newSelectedState);
        pageContext?.setSelectedAd(adRecord);
        toggleExpand();
    };

    const selectGroup=(group:DropDownListChangeEvent)=>{
        pageContext?.setTrafficFilter(prevFilter=>({...prevFilter,group:group.value}));
        setSelGroup(group.value);
    }

    const selectFilter=(filter:DropDownListChangeEvent)=>{
        pageContext?.setTrafficFilter(prevFilter=>({...prevFilter,filter:filter.value}));
        setSelFilter(filter.value);
    }

    const selectPagDate=(date:DatePickerChangeEvent)=>{
        if (date.value){
        pageContext?.setTrafficFilter(prevFilter=>({...prevFilter,pagDate:date.value}));
            //setSelPagDate(date.value);
        }
    }

    const selectPagEndDate=(date:DatePickerChangeEvent)=>{
        if (date.value){
            pageContext?.setTrafficFilter(prevFilter=>({...prevFilter,pagEndDate:date.value}));
            //setSelPagEndDate(date.value);
        }
    }
    const filterTrafficList=()=>{
        //var group = selGroup?.groupId || "";
        var group = pageContext?.trafficFilter.group.groupId || "";

        //var filter = selFilter.value;
        var filter = pageContext?.trafficFilter.filter.value;

        var pagDate = "";
        var pagEndDate = "";
        // if (selpagDate) {
        //     pagDate = selpagDate.toISOString();
        // }
        if (pageContext?.trafficFilter.pagDate) {
            pagDate = pageContext.trafficFilter.pagDate.toISOString();
        }
        // if (selpagEndDate){
        //     pagEndDate=selpagEndDate.toISOString();
        // }
         if (pageContext?.trafficFilter.pagEndDate){
            pagEndDate=pageContext.trafficFilter.pagEndDate.toISOString();
        }
        fillTrafficGrid(group, filter, pagDate, pagEndDate).then(data=>{
            setDashData(data);
            setDataResult(process(data, pageContext?.trafficDataState||dataState));
            pageContext?.setShowLoading(false);
        });
    }

    const filterAssignCC=(e:DropDownListFilterChangeEvent)=>{
        getTrafficUserList().then(data=>{
            if (data){
                const filteredData:trafficUser[] = filterBy(data,e.filter)    
                setTrafficUsers(filteredData);
    
            }
        })
    }   
    
    const filterAssignStatus=(e:DropDownListFilterChangeEvent)=>{
        getTrafficStatusList().then(data=>{
            if (data){
                const filteredData:trafficStatus[] = filterBy(data,e.filter)    
                setTrafficStatus(filteredData);
    
            }
        })
    }   
    
    const filterAssignSubStatus=(e:DropDownListFilterChangeEvent)=>{
        getTrafficCCSubStatusList().then(data=>{
            if (data){
                const filteredStatusData:trafficStatus[] = filterBy(data,e.filter)    
                setTrafficCCSubStatus(filteredStatusData);
            }
        })
    }   


    const fillTrafficUsers=(()=>{
        getTrafficUserList().then(data=>{
            console.log(data);
            setTrafficUsers(data);
        })
    });

    const fillTrafficStatus=()=>{
        getTrafficStatusList().then(data=>{
            setTrafficStatus(data);
        })
    }

    const fillTrafficCCSubStatus=()=>{
        getTrafficCCSubStatusList().then(data=>{
            setTrafficCCSubStatus(data);
        })
    }

    const trafficUserItem=(li: ReactElement<HTMLLIElement>, itemProps:ListItemProps)=>{
        const itemChildren=(
            <span>
                {itemProps.dataItem.fullname} ({itemProps.dataItem.username})
            </span>
        )
        return cloneElement(li,li.props,itemChildren);
    }

    const trafficUserValue=(assignedTo:string)=>{
        trafficUsers.map((user:trafficUser)=>{
                 if (user.username==assignedTo){
                     setTrafficAssignedTo(user);
                 }
         });
    }
    const trafficStatusValue = (selStatus:string)=>{
        trafficStatus.map((status:trafficStatus)=>{
            if (status.status==selStatus){
                 setTrafficSelStatus(status);
            }
        });
    }
    const trafficCCSubStatusValue = (selStatus:string)=>{
        trafficCCSubStatus.map((status:trafficStatus)=>{
            if (status.status==selStatus){
                 setTrafficSelCCSubStatus(status);
            }
        });
    }

    const assignAll=()=>{
        console.log("Assign All");
        setShowBulkAssign(true);
    }

    const hideBulkAssign=()=>{
        setShowBulkAssign(false);
    }

    const selBulkAssignUser=(e:DropDownListChangeEvent)=>{
        setBulkAssignUser(e.value);
    }

    const requestCreativeClick=()=>{
        setCreativeStatusFilter().then(()=>{
            console.log("Request Creative");
            var recordCount = dataResult.total;
            if (recordCount>0){
                var creativeSetStatus = pageContext?.atolStatuses.CreativeRequestedSetStatus;
                setCreativeMsg("You are about to change the status of " + recordCount + " ads to " + creativeSetStatus + ". <strong>This action can not be undone.</strong> Are you sure you wish to contine?")
                setShowRequestCreative(true);
            }
        })
    }

    const hideRequestCreative=()=>{
        setShowRequestCreative(false);
    }

    const confirmRequestCreative=()=>{
        console.log("Confirm request creative");
        var selectedAds:Array<string> = [];
        dataResult.data.map((data)=>{
            selectedAds.push(data.element);
        });
        if (selectedAds.length>0){
            requestCreative(selectedAds)
        }
        console.log(selectedAds);
    }

    const setCreativeStatusFilter=async ()=>{
        console.log(pageContext?.trafficDataState);
        var actFilters:CompositeFilterDescriptor
        if (pageContext?.trafficDataState.filter){
           actFilters  = pageContext?.trafficDataState.filter;
        }else{
            actFilters = {filters:[], logic:"and"}
        }
        if (pageContext?.atolStatuses.CreativeRequestedCheckStatus){
            const creativeCheckStatus=pageContext?.atolStatuses.CreativeRequestedCheckStatus.split(",");
            console.log(creativeCheckStatus);
            if (creativeCheckStatus.length>1){
                const newCompFilter:CompositeFilterDescriptor={logic:"or",filters:[]}
                creativeCheckStatus.forEach(item=>{
                    newCompFilter.filters.push({field:"status",value:item,operator:"eq"});
                });
                actFilters?.filters.push(newCompFilter);
                console.log(actFilters);
                pageContext.setTrafficDataState(({...pageContext?.trafficDataState,filter:actFilters})); 
                setDataState(({...dataState,filter:actFilters}));        
            }
        }
        //console.log(actFilters);
    }

    const trafficAssignCC=(event:DropDownListChangeEvent)=>{
        var selected=event.value;
        console.log(selected);
        var assignedTo=selected.username;
        var element = pageContext?.selectedAd.element;
        if (element && assignedTo){
            updateTraffic(element,"assignedTo",assignedTo).then(()=>{
                    setTrafficAssignedTo(selected);
                    pageContext?.setSelectedAd(prevObject=>({...prevObject,assignedTo:assignedTo,assignedFullName:selected.fullName}));
    
            })
        }
    
    }
    
    const trafficSetStatus=(event:DropDownListChangeEvent)=>{
        var selected=event.value;
        console.log(selected);
        var status=selected.status;
        var element = pageContext?.selectedAd.element;
        if (element && status){
            updateTraffic(element,"status",status).then(()=>{
                    setTrafficSelStatus(selected);
                    pageContext?.setSelectedAd(prevObject=>({...prevObject,trafficStatus:status}));
    
            })
        }
    
    }
    
    const trafficSetCCSubStatus=(event:DropDownListChangeEvent)=>{
        var selected=event.value;
        console.log(selected);
        var status=selected.status;
        var element = pageContext?.selectedAd.element;
        if (element && status){
            updateTraffic(element,"ccStatus",status).then(()=>{
                    setTrafficSelCCSubStatus(selected);
                    pageContext?.setSelectedAd(prevObject=>({...prevObject,ccSubStatus:status}));
            })
        }
    
    }
    


    const detailItem=(props:GridDetailRowProps)=>{
        const dataItem = props.dataItem;
        console.log(dataItem);
        const assignedTo = props.dataItem.assignedTo;
        trafficUserValue(dataItem.assignedTo);
        trafficStatusValue(dataItem.trafficStatus);
        trafficCCSubStatusValue(dataItem.trafficCCSubStatus);
        return(
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col' style={{paddingRight:"10px"}}>
                        <fieldset>
                            <div>Assigned to:</div>
                            <DropDownList dataItemKey="username" textField="fullname" data={trafficUsers} itemRender={trafficUserItem} value={trafficAssignedTo} onChange={trafficAssignCC} filterable={true} onFilterChange={filterAssignCC}/>
                        </fieldset>
                    </div>
                    <div className='col' style={{paddingRight:"10px"}}>
                        <fieldset>
                            <div>Traffic status:</div>
                            <DropDownList dataItemKey="status" textField="status" data={trafficStatus} value={trafficSelStatus} onChange={trafficSetStatus} filterable={true} onFilterChange={filterAssignStatus}/>
                        </fieldset>
                    </div>
                    <div className='col' style={{paddingRight:"10px"}}>
                        <fieldset>
                            <div>CC sub status:</div>
                            <DropDownList dataItemKey="status" textField="status" data={trafficCCSubStatus} value={trafficSelCCSubStatus} onChange={trafficSetCCSubStatus} filterable={true} onFilterChange={filterAssignSubStatus}/>
                        </fieldset>
                    </div>
                </div>
            </div>
        )
    }

    const filterOnClick=()=>{
        pageContext?.setShowLoading(true);
        filterTrafficList()
    }


    const trafficBulkAssignCC=()=>{
        console.log(bulkAssignUser);
        if (bulkAssignUser){
            var assignedTo=bulkAssignUser.username;
            setShowBulkAssign(false);
            dataResult.data.forEach((data)=>{
                var element = data.element;
                if (element&&assignedTo){
                    updateTraffic(element,"assignedTo",assignedTo).then(()=>{
                        console.log("Assigned " + element + " to " + assignedTo);
                    })
                }
            });
        }
    }


    const thisGrid=()=>{
        const isColumnFiltered = (columnField: string) => {
            var isFilter = false;
            if (dataState.filter){
                dataState.filter.filters.forEach(c=>{
                    (c as CompositeFilterDescriptor).filters.forEach(f=>{
                        if ((f as FilterDescriptor).field===columnField){
                            isFilter=true;
                        }
                    })
                })
            }
            return isFilter;                
        };
        return(
        <Grid
            id={props.id}
            className='dashGrid'
            sortable={true}
            selectable={{ enabled:true, mode: 'single' }}
            pageable={{
                info:true,                
                pageSizeValue: 20
            }}
            {...pageContext?.trafficDataState}
            //{...dataState}
            onDataStateChange={onDataStateChange}
            //onPageChange={pageChange}
            total={dataResult.total}
            reorderable={false}
            dataItemKey={'element'}
            data={dataResult.data.map((item)=>({
                 ...item, 'selected':selectedState[idGetter(item)]
             }))}
            detail={detailItem}
            //skip={page.skip}
            //take={page.take}
            columnMenuIcon={filterIcon}
            //selectedField={'selected'}
            onSelectionChange={onSelectionChange}
            onColumnReorder={props.reorderCols}
        >
            <GridToolbar>
            <DropDownList
                data={ruGroups}
                dataItemKey='groupId'
                textField='groupName'
                //value={selGroup}
                value={pageContext?.trafficFilter.group}
                onChange={selectGroup}
                style={{marginRight:"10px"}}            
            />
            <DropDownList
                data={[
                        { name: "Show All", value: 0 },
                        { name: "My Ads (All Groups)", value: 1 },
                        { name: "My Ads and Unassigned", value: 2 },
                        { name: "Only Unassigned", value: 3 },
                        { name: "All Assigned (Filtered Group)", value: 4 }
                    ]}
                dataItemKey='value'
                textField='name'
                //value={selFilter}
                value={pageContext?.trafficFilter.filter}
                onChange={selectFilter}
                style={{marginRight:"10px"}}            

            />
            <DatePicker
                id='trafficPagDate'
                onChange={selectPagDate}
                //value={selpagDate}
                value={pageContext?.trafficFilter.pagDate}
                style={{marginRight:"10px"}}            
            />
            <DatePicker
                id='trafficPagEndDate'
                onChange={selectPagEndDate}
                //value={selpagEndDate}
                value={pageContext?.trafficFilter.pagEndDate}
                style={{marginRight:"10px"}}            
            />
            <Button title="Filter" themeColor={'primary'} type="button" onClick={filterOnClick} style={{marginLeft:"10px",marginRight:"10px"}}>Filter/Refresh</Button>
            <Button title="Assign" themeColor={'primary'} type="button" onClick={assignAll} style={{marginRight:"10px"}}>Assign All</Button>
            <Button title="Creative" themeColor={'primary'} type="button" onClick={requestCreativeClick} style={{marginRight:"10px"}}>Request Creative</Button>
            
            {props.export?
                <Button title="Export Excel" themeColor={'primary'} type="button" onClick={excelExport}>
                    Export to Excel
                </Button>
            :null}
            </GridToolbar>

            {props.cols.map((column)=>{
                //console.og(column);
                return(
                    <Column 
                        {...(column.minScreenWidth && column.minScreenWidth>0 ? {media: `(min-width:${column.minScreenWidth}px)`} : {})}
                        field={column.field} 
                        title={column.title} 
                        width={column.width}
                        format={column.format}
                        key={"element"}
                        cells={{data:(cellProps)=>(
                            column.format!=null?formatColumn(cellProps):<td {...cellProps.tdProps}>{cellProps.dataItem[column.field]}</td>                            
                        )}}
                        columnMenu={column.filter ? ColumnMenu : undefined} 
                    />
                );
            })}
        </Grid>
        );
    }

    
    useEffect(() => {
        getUserRollUpGroups().then(data=>{
            console.log(data);
            data.map((data: rollUpGroup) => {
                if (data.primary){
                    console.log(data)
                    //setSelGroup(data);
                    pageContext?.setTrafficFilter(prevFilter=>({...prevFilter,group:data}));

                }
            });
            fillTrafficUsers();
            fillTrafficStatus();
            fillTrafficCCSubStatus();
            setRuGroups(data);
            pageContext?.setShowLoading(true);                
            filterTrafficList();
            gSettings().then(settings => setLocale(settings.Locale));
        });
    }, []);

    useEffect(()=>{
        setDataResult(process(dashData, pageContext?.trafficDataState ?? dataState));
    },[pageContext?.trafficDataState])

    return (
        <>
        {props.export?
            <ExcelExport data={dashData} ref={_export}>
                {thisGrid()}
            </ExcelExport>
        : thisGrid()
        }
        {showBulkAssign?<Dialog title={"Assign all selected ads"} onClose={hideBulkAssign}>
            <p>All ads in the current filtered results will be assigned to the selected user.</p>
            <DropDownList dataItemKey="username" textField="fullname" data={trafficUsers} itemRender={trafficUserItem} value={bulkAssignUser} onChange={selBulkAssignUser}/>
            <DialogActionsBar>
                <Button type="button" onClick={hideBulkAssign} themeColor={"secondary"}>Cancel</Button>
                <Button type="button" themeColor={"primary"} onClick={trafficBulkAssignCC}>Assign</Button>
            </DialogActionsBar>
        </Dialog>:null}
        {showRequestCreative?
            dataResult.data.length>500?
            <AlertDialog type='DANGER' title='Too many records' message='The selected data exceeds the maximum of 500 records. Some ads may not be included in this action. Please refine your search to reduce the number of ads selected and try again.' onClose={hideRequestCreative} confirmButtonText='Ok'></AlertDialog>
            :
            <ConfirmDialog type="WARN" title='WARNING!' message={creativeMsg} confirmButtonText='Yes' cancelButtonText='No' onConfirm={confirmRequestCreative} onClose={hideRequestCreative}></ConfirmDialog>
        :null}
         </>
    );
}

export function SearchGrid (props:dashboardGridProps){
    const [dashData, setDashData] = useState([]);
    const [dataState, setDataState]=useState<State>(initialDataState);
    const [dataResult, setDataResult]=useState<DataResult>(process(dashData,dataState));
    const pageContext = useContext(PageContext);
    const userContext=useContext(UserContext);
    const [selectedState, setSelectedState] = React.useState<{
        [id: string]: boolean | number[];
    }>({});
    const [locale, setLocale] = useState<string | undefined>(undefined);

    const [page, setPage] = React.useState<PageState>(initialPageState);
    const idGetter = getter('element');
    const [showBulkAssign, setShowBulkAssign]= useState(false);
    const [showRequestCreative, setShowRequestCreative]=useState(false);
    const [bulkAssignUser, setBulkAssignUser]=useState<trafficUser | undefined>();
    const [creativeMsg,setCreativeMsg]=useState("");
    const [trafficUsers, setTrafficUsers] = useState([]);
    const [gridKey, setGridKey]=useState(1);

    interface StatusItem {
        status: string;
        color: string;
    }

     const onDataStateChange = (e: GridDataStateChangeEvent) => {
        const NewDataState = {...e.dataState, skip:e.dataState.skip===undefined?0:e.dataState.skip, take:e.dataState.take===undefined?20:e.dataState.take}
        setDataState(NewDataState);
        //getData();
        const newStateData = process(dashData,NewDataState);
        setDataResult(newStateData);
    };

    const [statList, setStatList] = useState<StatusItem[]>([]);
   
    const pageChange = (event: GridPageChangeEvent) => {
        const targetEvent = event.targetEvent as PagerTargetEvent;        
        setPage({
            ...event.page,
            take:20
        });
    }

    const statusList = ()=>{
        const statList = getStatusList()
        .then(data=>{setStatList(data)});
    }



    function formatColumn(gridCell:GridCustomCellProps) {
        //, format:string, fieldName:string
        //console.log(gridCell);
        //console.log(gridCell.field);
        const fieldName=gridCell.field;
        const format: string = gridCell.format||'';
        
        switch (format){
           case "status":
                //format a status list column
                const matchStat = statList.find(item => item.status === gridCell.dataItem[fieldName||'']);
                const color = matchStat?.color.replace(" ", "_");
                return (
                    <td {...gridCell.tdProps}>
                        <span style={{ color: color }}>
                            <FontAwesomeIcon icon={faCircle}></FontAwesomeIcon>
                        </span>&emsp;{gridCell.dataItem.status}
                    </td>
                );
                break;
            case "longdate":
                //format a long date to date format
                console.log(fieldName);
                if (fieldName){
                    console.log(gridCell.dataItem);
                    console.log(gridCell.dataItem[fieldName])
                }
                const longStr = (gridCell.dataItem[fieldName||'']).toString();
                const longDate:longDateTime = {
                    year:longStr.substring(0,4),
                    month:longStr.substring(4,6),
                    day:longStr.substring(6,8),                    
                }
                const newDate=new Date(longDate.month+"/"+longDate.day+"/"+longDate.year);
                 return (
                     <td {...gridCell.tdProps}>
                        {newDate.toLocaleDateString(locale)}
                     </td>
                 )
                break;
            case "longdatetime":
                const longDtStr = (gridCell.dataItem[fieldName||'']).toString();
                const longDateTime:longDateTime = {
                    year:longDtStr.substring(0,4),
                    month:longDtStr.substring(4,6),
                    day:longDtStr.substring(6,8),
                    hour:longDtStr.substring(8,10),
                    minute:longDtStr.substring(10,12),
                    second:longDtStr.substring(12,14),
                }
                //console.log(longDateTime);

                const newDateTime=new Date(longDateTime.month+"/"+longDateTime.day+"/"+longDateTime.year +" "+ longDateTime.hour + ":" + longDateTime.minute + ":" + longDateTime.second);
                //console.log(newDateTime);

                return (
                    <td {...gridCell.tdProps}>
                    {locale ? newDateTime.toLocaleString(locale) : newDateTime.toLocaleString()}
                    </td>
                )
                break;
            default:
                return(
                    <td {...gridCell.tdProps}>
                        {gridCell.field ? gridCell.dataItem[gridCell.field] : null}
                    </td>
                )
                break;
        }        
    }
    const _export = React.useRef<ExcelExport | null>(null);
    const excelExport = () => {
        console.log(_export.current);
        console.log(dashData);
        if (dashData){
            if (_export.current !== null) {
                _export.current.save(dashData);
            }
        }
    };
    const toggleExpand=()=>pageContext?.setShowExpand(!pageContext?.showExpand);

    const onSelectionChange = (event: GridSelectionChangeEvent) => {
        console.log("Selection changed");
        const adRecord:adRecord=event.startDataItem;
        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedState,
            dataItemKey: "element"
        });
        const getNextElement = pageContext?.page.fromGetNext;
        if (getNextElement){
            releaseGetNext(getNextElement);
        }
        //console.log(Object.keys(newSelectedState)[0]);
        setSelectedState(newSelectedState);
        pageContext?.setSelectedAd(adRecord);
        toggleExpand();
    };

    const getData=()=>{
        const searchFields = pageContext?.page.fields;
        console.log(searchFields);
        statusList();
        if (searchFields){
            runQuery(searchFields).then(data => {
                setDashData(data);
                //console.log(data);
                setDataResult(process(data, dataState));
                if (data.length===1){
                    console.log("Only one record select it.");
                    var adRecord = data[0];
                    pageContext?.setSelectedAd(adRecord);
                    toggleExpand();            
                }
            });    
        }
    }

    const assignAll=()=>{
        console.log("Assign All");
        setShowBulkAssign(true);
    }

    const hideBulkAssign=()=>{
        setShowBulkAssign(false);
    }

    const fillTrafficUsers=(()=>{
        getTrafficUserList().then(data=>{
            setTrafficUsers(data);
        })
    });

    const selBulkAssignUser=(e:DropDownListChangeEvent)=>{
        setBulkAssignUser(e.value);
    }

    const trafficUserItem=(li: ReactElement<HTMLLIElement>, itemProps:ListItemProps)=>{
        const itemChildren=(
            <span>
                {itemProps.dataItem.fullname} ({itemProps.dataItem.username})
            </span>
        )
        return cloneElement(li,li.props,itemChildren);
    }

    const confirmRequestCreative=()=>{
        console.log("Confirm request creative");
        var selectedAds:Array<string> = [];
        dataResult.data.map((data)=>{
            selectedAds.push(data.element);
        });
        if (selectedAds.length>0){
            requestCreative(selectedAds)
        }
        console.log(selectedAds);
    }

    const hideRequestCreative=()=>{
        setShowRequestCreative(false);
    }

     const requestCreativeClick=()=>{
        setCreativeStatusFilter().then(()=>{
            console.log("Request Creative");
            var recordCount = dataResult.total;
            if (recordCount>0){
                var creativeSetStatus = pageContext?.atolStatuses.CreativeRequestedSetStatus;
                setCreativeMsg("You are about to change the status of " + recordCount + " ads to " + creativeSetStatus + ". <strong>This action can not be undone.</strong> Are you sure you wish to contine?")
                setShowRequestCreative(true);
            }
        })
    }

    const setCreativeStatusFilter=async ()=>{
        console.log(pageContext?.trafficDataState);
        var actFilters:CompositeFilterDescriptor
        if (pageContext?.trafficDataState.filter){
           actFilters  = pageContext?.trafficDataState.filter;
        }else{
            actFilters = {filters:[], logic:"and"}
        }
        if (pageContext?.atolStatuses.CreativeRequestedCheckStatus){
            const creativeCheckStatus=pageContext?.atolStatuses.CreativeRequestedCheckStatus.split(",");
            console.log(creativeCheckStatus);
            if (creativeCheckStatus.length>1){
                const newCompFilter:CompositeFilterDescriptor={logic:"or",filters:[]}
                creativeCheckStatus.forEach(item=>{
                    newCompFilter.filters.push({field:"status",value:item,operator:"eq"});
                });
                actFilters?.filters.push(newCompFilter);
                console.log(actFilters);
                pageContext.setTrafficDataState(({...pageContext?.trafficDataState,filter:actFilters})); 
                setDataState(({...dataState,filter:actFilters}));        
            }
        }
        //console.log(actFilters);
    }

    const trafficBulkAssignCC=()=>{
        console.log(bulkAssignUser);
        if (bulkAssignUser){
            var assignedTo=bulkAssignUser.username;
            setShowBulkAssign(false);
            dataResult.data.forEach((data)=>{
                var element = data.element;
                if (element&&assignedTo){
                    updateTraffic(element,"assignedTo",assignedTo).then(()=>{
                        console.log("Assigned " + element + " to " + assignedTo);
                    })
                }
            });    
        }
    }

    // const thisGrid=()=>{

    //     const isColumnFiltered = (columnField: string) => {
    //         var isFilter = false;
    //         if (dataState.filter){
    //             dataState.filter.filters.forEach(c=>{
    //                 (c as CompositeFilterDescriptor).filters.forEach(f=>{
    //                     if ((f as FilterDescriptor).field===columnField){
    //                         isFilter=true;
    //                     }
    //                 })
    //             })
    //         }
    //         return isFilter;                
    //     };

    //     return(
    //     <Grid
    //         key={gridKey}
    //         id={props.id}
    //         className='dashGrid'
    //         sortable={true}
    //         selectable={{ enabled:true, mode: 'single' }}
    //         pageable={{
    //              info:true,                
    //              pageSizeValue: 20
    //         }}            
    //         {...dataState}
    //         onDataStateChange={onDataStateChange}
    //         total={dataResult.total}
    //         reorderable={false}
    //         dataItemKey={'UID'}
    //         data={dataResult.data.map((item)=>({
    //              ...item, 'selected':selectedState[idGetter(item)]
    //          }))}
    //         columnMenuIcon={filterIcon}
    //         onSelectionChange={onSelectionChange}
    //         onColumnReorder={props.reorderCols}
    //         >
    //         <GridToolbar>
    //         <Button title="Refresh" themeColor={'primary'} type='button' onClick={getData}>Refresh</Button>
    //         {props.export?
    //             <Button title="Export Excel" themeColor={'primary'} type="button" onClick={excelExport}>
    //                 Export to Excel
    //             </Button>
    //         :null}
    //         {userContext?.user.trafficUser===true?            
    //             <>
    //             <Button title="Assign" themeColor={'primary'} type="button" onClick={assignAll} style={{marginRight:"10px"}}>Assign All</Button>
    //             <Button title="Creative" themeColor={'primary'} type="button" onClick={requestCreativeClick} style={{marginRight:"10px"}}>Request Creative</Button>
    //             </>
    //         :null}
    //         </GridToolbar>
    //         {props.cols.map((column)=>{
    //             //console.log(column);
    //             return(
    //                 <GridColumn 
    //                     key={column.field}
    //                     field={column.field} 
    //                     title={column.title} 
    //                     width={column.width}
    //                     format={column.format}
    //                     headerClassName={isColumnFiltered(column.field)?"filteredColumn":""}
    //                     cells={{data:(cellProps)=>(
    //                         column.format!=null?formatColumn(cellProps):<td {...cellProps.tdProps}>{cellProps.dataItem[column.field]}</td>                            
    //                     )}}
    //                     columnMenu={column.filter ? ColumnMenu : undefined} 
    //                 />
    //             );
    //         })}
    //     </Grid>
    //     );
    // }
    const thisGrid=()=>{
        const isColumnFiltered = (columnField: string) => {
            var isFilter = false;
            if (dataState.filter){
                dataState.filter.filters.forEach(c=>{
                    (c as CompositeFilterDescriptor).filters.forEach(f=>{
                        if ((f as FilterDescriptor).field===columnField){
                            isFilter=true;
                        }
                    })
                })
            }
            return isFilter;                
        };
        return(
        <Grid
            id={props.id}
            key={gridKey}
            className='dashGrid'
            sortable={true}
            //sort={sort}
            selectable={{ enabled:true, mode: 'single' }}
            pageable={true}
            pageSize={20}            
            {...dataState}
            onDataStateChange={onDataStateChange}
            //onPageChange={pageChange}
            total={dataResult.total}
            reorderable={true}
            dataItemKey={'element'}
            data={dataResult.data.map((item)=>({
                 ...item, 'selected':selectedState[idGetter(item)]
             }))}
            columnMenuIcon={filterIcon}
            //selectedField={'selected'}
            onSelectionChange={onSelectionChange}
            onColumnReorder={props.reorderCols}
        >
            <GridToolbar>
            <Button title="Refresh" themeColor={'primary'} type="button" onClick={getData} style={{marginRight:"10px"}}>Refresh</Button>
            {props.export?
                <Button title="Export Excel" themeColor={'primary'} type="button" onClick={excelExport}>
                    Export to Excel
                </Button>
            :<></>}
            {userContext?.user.trafficUser===true?            
                 <>
                 <Button title="Assign" themeColor={'primary'} type="button" onClick={assignAll} style={{marginRight:"10px"}}>Assign All</Button>
                 <Button title="Creative" themeColor={'primary'} type="button" onClick={requestCreativeClick} style={{marginRight:"10px"}}>Request Creative</Button>
                 </>
             :<></>}
            </GridToolbar>

            {props.cols.map((column)=>{
                //console.og(column);
                return(
                    <Column 
                        {...(column.minScreenWidth && column.minScreenWidth>0 ? {media: `(min-width:${column.minScreenWidth}px)`} : {})}
                        field={column.field} 
                        title={column.title} 
                        width={column.width}
                        format={column.format}
                        key={"element"}
                        headerClassName={isColumnFiltered(column.field)?"filteredColumn":""}
                        cells={{data:(cellProps)=>(
                            column.format!=null?formatColumn(cellProps):<td {...cellProps.tdProps}>{cellProps.dataItem[column.field]}</td>                            
                        )}}
                        columnMenu={column.filter ? ColumnMenu : undefined} 
                    />
                );
            })}
        </Grid>
        );
    }

    const forceRender=()=>{
       console.log("Force Render");
        setGridKey(gridKey+1);
    }

    useEffect(()=>{
        forceRender();
    },[props.cols])

    
    useEffect(() => {
        getData();
        if (userContext?.user.trafficUser===true){
             fillTrafficUsers();
        }
        gSettings().then(settings => setLocale(settings.Locale));
    }, [pageContext?.page.fields]);

    useEffect(()=>{
        getData();
    },[])

    return (
        <>
        {props.export?
            <ExcelExport data={dashData} ref={_export}>
                {thisGrid()}
            </ExcelExport>
        : thisGrid()
        }
        {showBulkAssign?
        <Dialog title={"Assign all selected ads"} onClose={hideBulkAssign}>
            <p>All ads in the current filtered results will be assigned to the selected user.</p>
            <DropDownList dataItemKey="username" textField="fullname" data={trafficUsers} itemRender={trafficUserItem} value={bulkAssignUser} onChange={selBulkAssignUser}/>
            <DialogActionsBar>
                <Button type="button" onClick={hideBulkAssign} themeColor={"secondary"}>Cancel</Button>
                <Button type="button" themeColor={"primary"} onClick={trafficBulkAssignCC}>Assign</Button>
            </DialogActionsBar>
        </Dialog>:null}
        {showRequestCreative?
            dataResult.data.length>500?
            <AlertDialog type='DANGER' title='Too many records' message='The selected data exceeds the maximum of 500 records. Some ads may not be included in this action. Please refine your search to reduce the number of ads selected and try again.' onClose={hideRequestCreative} confirmButtonText='Ok'></AlertDialog>
            :
            <ConfirmDialog type="WARN" title='WARNING!' message={creativeMsg} confirmButtonText='Yes' cancelButtonText='No' onConfirm={confirmRequestCreative} onClose={hideRequestCreative}></ConfirmDialog>
        :null}
         </>
    );
}

export function MMGrid (props:dashboardGridProps){
    const [dashData, setDashData] = useState<any[]>([]);
    const [dataState, setDataState]=useState<State>(initialDataState);
    const [dataResult, setDataResult]=useState<DataResult>(process(dashData,dataState));
    const [selectedState, setSelectedState] = React.useState<{
        [id: string]: boolean | number[];
    }>({});
    const [locale, setLocale] = useState<string | undefined>(undefined);

    const [page, setPage] = React.useState<PageState>(initialPageState);
    const idGetter = getter('element');
    const [ruGroups,setRuGroups]=useState<Array<rollUpGroup>>([]);
    const [selGroup, setSelGroup]=useState<rollUpGroup>();
    const [selFilter, setSelFilter]=useState<filterItem>({ name: "Show All", value: 0 });
    const [selpagDate,setSelPagDate]=useState<Date>();
    const [selpagEndDate,setSelPagEndDate]=useState<Date>();
    const [trafficUsers, setTrafficUsers] = useState([]);
    const [trafficStatus,setTrafficStatus]=useState([]);
    const [trafficCCSubStatus,setTrafficCCSubStatus]=useState([]);
    const [trafficAssignedTo, setTrafficAssignedTo]=useState<trafficUser>({fullname:"", username:""});
    const [trafficSelStatus,setTrafficSelStatus]=useState<trafficStatus>({status:"",color:"",displayOrder:0});
    const [trafficSelCCSubStatus,setTrafficSelCCSubStatus]=useState<trafficStatus>({status:"",color:"",displayOrder:0});
    const [showBulkAssign, setShowBulkAssign]= useState(false);
    const [showRequestCreative, setShowRequestCreative]=useState(false);
    const [bulkAssignUser, setBulkAssignUser]=useState();

    interface StatusItem {
        status: string;
        color: string;
    }

    const onDataStateChange = (e: GridDataStateChangeEvent) => {
        const NewDataState = {...e.dataState, skip:e.dataState.skip===undefined?0:e.dataState.skip, take:e.dataState.take===undefined?20:e.dataState.take}
        setDataState(NewDataState);
        const newStateData = process(dashData,NewDataState);
        setDataResult(newStateData);
    };

    const [statList, setStatList] = useState<StatusItem[]>([]);
    const pageChange = (event: GridPageChangeEvent) => {
        const targetEvent = event.targetEvent as PagerTargetEvent;        
        setPage({
            ...event.page,
            take:20
        });
    }

    const statusList = ()=>{
        const statList = getStatusList()
        .then(data=>{setStatList(data)});
    }

    function formatColumn(gridCell:GridCustomCellProps) {
        //, format:string, fieldName:string
        //console.log(gridCell);
        //console.log(gridCell.field);
        const fieldName=gridCell.field;
        const format: string = gridCell.format||'';
        
        switch (format){
           case "status":
                //format a status list column
                const matchStat = statList.find(item => item.status === gridCell.dataItem[fieldName||'']);
                const color = matchStat?.color.replace(" ", "_");
                return (
                    <td {...gridCell.tdProps}>
                        <span style={{ color: color }}>
                            <FontAwesomeIcon icon={faCircle}></FontAwesomeIcon>
                        </span>&emsp;{gridCell.dataItem.status}
                    </td>
                );
                break;
            case "longdate":
                //format a long date to date format
                const longStr = (gridCell.dataItem[fieldName||'']).toString();
                const longDate:longDateTime = {
                    year:longStr.substring(0,4),
                    month:longStr.substring(4,6),
                    day:longStr.substring(6,8),                    
                }
                const newDate=new Date(longDate.month+"/"+longDate.day+"/"+longDate.year);
                 return (
                     <td {...gridCell.tdProps}>
                        {newDate.toLocaleDateString(locale)}
                     </td>
                 )
                break;
            case "longdatetime":
                const longDtStr = (gridCell.dataItem[fieldName||'']).toString();

                //const longDateTime:longDateTime = {
                //    year:longDtStr.substring(0,4),
                //    month:longDtStr.substring(4,6),
                //    day:longDtStr.substring(6,8),
                //    hour:longDtStr.substring(8,10),
                //    minute:longDtStr.substring(10,12),
                //    second:longDtStr.substring(12,14),
                //}
                //console.log(longDateTime);

                //const newDateTime=new Date(longDateTime.month+"/"+longDateTime.day+"/"+longDateTime.year +" "+ longDateTime.hour + ":" + longDateTime.minute + ":" + longDateTime.second);
                const newDateTime = new Date(longDtStr);
                //console.log(newDateTime);

                return (
                    <td {...gridCell.tdProps}>
                    {locale ? newDateTime.toLocaleString(locale) : newDateTime.toLocaleString()}
                    </td>
                )
                break;
            default:
                return(
                    <td {...gridCell.tdProps}>
                        {gridCell.field ? gridCell.dataItem[gridCell.field] : null}
                    </td>
                )
                break;
        }        
    }
    const _export = React.useRef<ExcelExport | null>(null);
    const excelExport = () => {
        if (_export.current !== null) {
            _export.current.save(dashData);
        }
    };
    const pageContext = useContext(PageContext);
    const userContext = useContext(UserContext);
    const toggleExpand=()=>pageContext?.setShowExpand(!pageContext?.showExpand);

    const onSelectionChange = (event: GridSelectionChangeEvent) => {
        console.log("Selection changed");
        //console.log(event.startDataItem);
        const jobRecord:adRecord=event.startDataItem;
        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedState,
            dataItemKey: "mmJobName"
        });
        //console.log(Object.keys(newSelectedState)[0]);
        setSelectedState(newSelectedState);
        pageContext?.setSelectedAd(jobRecord);
        toggleExpand();
    };

    const selectGroup=(group:DropDownListChangeEvent)=>{
        setSelGroup(group.value);
    }

    const selectFilter=(filter:DropDownListChangeEvent)=>{
        setSelFilter(filter.value);
    }

    const selectPagDate=(date:DatePickerChangeEvent)=>{
        if (date.value){
            setSelPagDate(date.value);
        }
    }

    const selectPagEndDate=(date:DatePickerChangeEvent)=>{
        if (date.value){
            setSelPagEndDate(date.value);
        }
    }
    const filterMMList=()=>{
        var filter = selFilter.value;
        fillToningJobList().then(data=>{
            setDashData(data);
            setDataResult(process(data, dataState));
        });
    }

    const fillTrafficUsers=(()=>{
        getTrafficUserList().then(data=>{
            setTrafficUsers(data);
        })
    });

    const fillTrafficStatus=()=>{
        getTrafficStatusList().then(data=>{
            setTrafficStatus(data);
        })
    }

    const fillTrafficCCSubStatus=()=>{
        getTrafficCCSubStatusList().then(data=>{
            setTrafficCCSubStatus(data);
        })
    }

    const trafficUserItem=(li: ReactElement<HTMLLIElement>, itemProps:ListItemProps)=>{
        const itemChildren=(
            <span>
                {itemProps.dataItem.fullname} ({itemProps.dataItem.username})
            </span>
        )
        return cloneElement(li,li.props,itemChildren);
    }

    const trafficUserValue=(assignedTo:string)=>{
        trafficUsers.map((user:trafficUser)=>{
                 if (user.username==assignedTo){
                     setTrafficAssignedTo(user);
                 }
         });
    }
    const trafficStatusValue = (selStatus:string)=>{
        trafficStatus.map((status:trafficStatus)=>{
            if (status.status==selStatus){
                 setTrafficSelStatus(status);
            }
        });
    }
    const trafficCCSubStatusValue = (selStatus:string)=>{
        trafficCCSubStatus.map((status:trafficStatus)=>{
            if (status.status==selStatus){
                 setTrafficSelCCSubStatus(status);
            }
        });
    }

    const assignAll=()=>{
        console.log("Assign All");
        setShowBulkAssign(true);
    }

    const hideBulkAssign=()=>{
        setShowBulkAssign(false);
    }

    const selBulkAssignUser=(e:DropDownListChangeEvent)=>{
        setBulkAssignUser(e.value);
    }

    const requestCreative=()=>{
        console.log("Request Creative");
        setShowRequestCreative(true);
    }

    const hideRequestCreative=()=>{
        setShowRequestCreative(false);
    }

    const confirmRequestCreative=()=>{
        console.log("Confirm request creative");
        var selectedAds:Array<string> = [];
        dataResult.data.map((data)=>{
            selectedAds.push(data.element);
        });
        console.log(selectedAds);
    }
    
    const mmDetailItem=(props:GridDetailRowProps)=>{
        const dataItem = props.dataItem;
        //console.log(dataItem);
        const specialInstructions = dataItem.specialInstructions;
        //console.log(specialInstructions);
        if (!specialInstructions || specialInstructions==""){
            return null;
        }else{
            return(
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col'>
                            {dataItem.specialInstructions}
                        </div>
                    </div>
                </div>
            )
        }
    }

    const CustomCell = (props: any) => {
        return <td {...props.tdProps}>{props.dataItem.specialInstructions !== "" && props.children}</td>;
    };

    const thisGrid=()=>{
        return(
        <Grid
            id={props.id}
            className='mmGrid'
            sortable={true}
            selectable={{ enabled:true, mode: 'single' }}
            pageable={{
                info:true,                
                pageSizeValue: 20
            }}
            {...dataState}
            onDataStateChange={onDataStateChange}
            //onPageChange={pageChange}
            total={dataResult.total}
            reorderable={false}
            dataItemKey={'mmJobName'}
            data={dataResult.data.map((item)=>({
                ...item, 'selected':selectedState[idGetter(item)]
            }))}
            detail={mmDetailItem}
            //skip={page.skip}
            //take={page.take}
            columnMenuIcon={filterIcon}
            //selectedField={'selected'}
            onSelectionChange={onSelectionChange}
            onColumnReorder={props.reorderCols}
            cells={{
                    hierarchy: {
                        data: CustomCell
                    }
                }}
        >
            <GridToolbar>
                {/* <input></input>
                <Button title="Search jobs" themeColor={'primary'} type='button'>Search</Button> */}
                <Button title="Refresh" themeColor={'primary'} type="button" onClick={filterMMList} style={{marginRight:"10px"}}>Refresh</Button>
                {props.export?
                    <Button title="Export Excel" themeColor={'secondary'} type="button" onClick={excelExport}>
                        Export to Excel
                    </Button>
                    
                :null}
            </GridToolbar>
        {props.cols.map((column)=>{
            //console.og(column);
            return(
                <Column 
                    {...(column.minScreenWidth && column.minScreenWidth>0 ? {media: `(min-width:${column.minScreenWidth}px)`} : {})}
                    field={column.field} 
                    title={column.title} 
                    width={column.width}
                    format={column.format}
                    key={"element"}
                    cells={{data:(cellProps)=>(
                        column.format!=null?formatColumn(cellProps):<td {...cellProps.tdProps}>{cellProps.dataItem[column.field]}</td>                            
                    )}}
                    columnMenu={column.filter ? ColumnMenu : undefined} 
                />
            );
        })}
        </Grid>
        );
    }

    
    useEffect(() => {
        filterMMList();
    }, []);

    return (
        <>
        {props.export?
            <ExcelExport data={dashData} ref={_export}>
                {thisGrid()}
            </ExcelExport>
        : thisGrid()
        }
        {showBulkAssign?<Dialog title={"Assign all selected ads"} onClose={hideBulkAssign}>
            <p>All ads in the current filtered results will be assigned to the selected user.</p>
            <DropDownList dataItemKey="username" textField="fullname" data={trafficUsers} itemRender={trafficUserItem} value={bulkAssignUser} onChange={selBulkAssignUser}/>
            <DialogActionsBar>
                <Button type="button" onClick={hideBulkAssign} themeColor={"secondary"}>Cancel</Button>
                <Button type="button" themeColor={"primary"}>Assign</Button>
            </DialogActionsBar>
        </Dialog>:null}
        {showRequestCreative?
            dataResult.data.length>500?
            <AlertDialog type='DANGER' title='Too many records' message='The selected data exceeds the maximum of 500 records. Some ads may not be included in this action. Please refine your search to reduce the number of ads selected and try again.' onClose={hideRequestCreative} confirmButtonText='Ok'></AlertDialog>
            :
            <ConfirmDialog type="WARN" title='WARNING!' message='You are about to change the status of X ads to STATUS. <strong>This action can not be undone.</strong> Are you sure you wish to contine?' confirmButtonText='Yes' cancelButtonText='No' onConfirm={confirmRequestCreative} onClose={hideRequestCreative}></ConfirmDialog>
        :null}
         </>
    );
}
